import { IDotXetChungChiThamSoXet } from "../../../model/response/xet-chung-chi/IDotXetChungChiThamSoXet";
import { IThamSoXetChungChi } from "../../../model/response/xet-chung-chi/IThamSoXetChungChi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDotXetChungChiThamSoXetActionsObj = {
    LOAD_BY_DOT_XET_START: 0,
    LOAD_BY_DOT_XET_SUCCESS: {} as IDotXetChungChiThamSoXet[],
    LOAD_BY_DOT_XET_ERROR: "",

    LOAD_NOT_EXISTS_DOT_XET_START: 0,
    LOAD_NOT_EXISTS_DOT_XET_SUCCESS: {} as IThamSoXetChungChi[],
    LOAD_NOT_EXISTS_DOT_XET_ERROR: "",

    SAVE_START: {} as IDotXetChungChiThamSoXet,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    UPDATE_THAM_SO_START: {} as IDotXetChungChiThamSoXet,
    UPDATE_THAM_SO_SUCCESS: undefined,
    UPDATE_THAM_SO_ERROR: "",

}

export const eDotXetChungChiThamSoXetActionIds = generateActionTypeIds(eDotXetChungChiThamSoXetActionsObj, "DOT_XET_CHUNG_CHI_THAM_SO_XET");
export type IDotXetChungChiThamSoXetActionTypes = IGenericActionType<typeof eDotXetChungChiThamSoXetActionsObj, "DOT_XET_CHUNG_CHI_THAM_SO_XET">;